/**
 * Stage 7A (F9): the `next=<path>` of a one-time sign-in link may only lead inside the app.
 * Returns the path when it is an in-app path, else null. Accepts only a value that starts with a single "/" (not "//",
 * not "/\"), has no scheme and no control characters, and stays that way after being decoded once more
 * (so "/%2Fevil.example" cannot slip through as "//evil.example"). `value` is already decoded once by URLSearchParams.
 */
/* eslint-disable no-control-regex -- control characters are exactly what is refused */
const ok = (v: string): boolean =>
  v.startsWith("/") && !v.startsWith("//") && !v.startsWith("/\\") && !/[\u0000-\u001f\u007f\\]/.test(v) && !/^\/*[a-z][a-z0-9+.-]*:/i.test(v);
/* eslint-enable no-control-regex */

export const inAppPath = (value: string | null | undefined): string | null => {
  if (!value || !ok(value)) return null;
  let again: string;
  try { again = decodeURIComponent(value); } catch { return null; }
  return ok(again) ? value : null;
};
